<template>
  <div class="coupon-card" @click="$emit('select', coupon)">
    <img v-lazy="coupon.posterUrl" alt="coupon" />
    <div class="coupon-info">
      <div class="coupon-points">
        <img :src="require('@/assets/icon/BevFamilyPoint.png')" alt="bev point" width="24" height="24" class="mr-1" />
        <span class="point-value">{{ $toLocal(coupon.redeemPoint) }}</span>
      </div>
      <div class="coupon-title">{{ coupon.title }}</div>
      <!-- <div class="coupon-expiry">แลกได้ถึง {{ $getDate(coupon.couponEndDate) }}</div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'CouponCard',
  props: {
    coupon: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
.coupon-card {
  width: 100%;
  min-height: 233px;
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
}

.coupon-card > img {
  width: calc(100% - 16px);
  height: 144px;
  margin: 8px;
  object-fit: cover;
  border-radius: 8px;
}

.coupon-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.coupon-title {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #000000;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 32px;
}

.coupon-points {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;
  padding: 2px;
  background-color: #005224;
}

.point-value {
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #ffffff;
}

.coupon-expiry {
  
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #727983;
}
</style>
